export default __webpack_public_path__ + "static/media/modeling_black.f9959f2c.png";